import { PackageOpen } from "lucide-react";
import type { ReactNode } from "react";

export function EmptyState({
  title,
  description,
  action
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="empty-state">
      <PackageOpen size={40} strokeWidth={1.4} />
      <h2>{title}</h2>
      <p>{description}</p>
      {action}
    </div>
  );
}

